import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface FormTooltipProps {
  description: string;
}

export function FormTooltip({ description }: FormTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger type="button" className="ms-1.5 inline-flex">
        <Info className="h-4 w-4 text-muted-foreground" />
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">{description}</TooltipContent>
    </Tooltip>
  );
}
